export const DEALER_KEY = "crm_dealer_info_v3";

export const defaultDealer = {
  name: "Headon Auto Sales / 1001241963 Ontario Inc.",
  reg: "5898994",
  hst_number: "795993831RT0002",
  address: "2059 Bayly St, Unit A2-6 Pickering Ontario L1V 2P8",
  phone: "(647) 930-2276",
  email: "",
  fi_manager: "Amit Mistry",
  authorized_rep: "Obaid Sallek",
};

export function loadDealer() {
  try {
    return { ...defaultDealer, ...JSON.parse(localStorage.getItem(DEALER_KEY) || "{}") };
  } catch {
    return defaultDealer;
  }
}

export const saveDealer = (d) => localStorage.setItem(DEALER_KEY, JSON.stringify(d));

/** Server-stored dealer letterhead wins, but only for fields that are actually filled in. */
export const mergeDealer = (base, remote) => ({
  ...base,
  ...Object.fromEntries(Object.entries(remote || {}).filter(([, v]) => v !== "" && v !== null && v !== undefined)),
});
